export default __webpack_public_path__ + "static/media/citizenship_icon.ee23d97c59c36bdc932b2263cd3c8601.svg";